import { $, $$ } from './utils';
import { createApp } from 'vue';

document.addEventListener(
    'DOMContentLoaded',
    () => {
        const modalContainers = $$('.modal');
        const triggers = $$('.modal-trigger');

        triggers.forEach((trigger) => {
            trigger.addEventListener(
                'click',
                (e) => {
                    const modal = $(e.target.getAttribute('data-modal'));

                    if (modal) {
                        modal.classList.remove('fade-out');
                        modal.classList.add('fade-in');
                    }
                    document.body.classList.add('modal__open');

                    e.preventDefault();
                },
                false,
            );
        });

        modalContainers.forEach((modalContainer) => {
            const handleClick = (e) => {
                modalContainer.classList.remove('fade-in');
                modalContainer.classList.add('fade-out');
                document.body.classList.remove('modal__open');
                e.preventDefault();
            };

            modalContainer.querySelector('.modal__overlay').addEventListener('click', handleClick, false);
            modalContainer.querySelector('.modal__close').addEventListener('click', handleClick, false);
        });

        // -------------------------
        // Global Vue modal logic
        // -------------------------
        const vueTriggers = document.querySelectorAll('[data-modal-component][data-modal-event][data-modal-id]');
        if (!vueTriggers || vueTriggers.length === 0) return;

        const firstTrigger = vueTriggers[0];
        if (!firstTrigger?.dataset) return;

        const componentName = firstTrigger.dataset.modalComponent;
        const eventName = firstTrigger.dataset.modalEvent;
        const modalId = firstTrigger.dataset.modalId;

        if (!componentName || !eventName || !modalId) return;

        const mountNodeId = `vue-modal-container--${modalId}`;
        let mountNode = document.getElementById(mountNodeId);
        if (!mountNode) {
            mountNode = document.createElement('div');
            mountNode.id = mountNodeId;
            document.body.appendChild(mountNode);
        }

        const importMap = {
            HeroModalContent: () => import('../components/modals/HeroModalContent.vue'),
        };

        const importer = importMap[componentName];
        if (!importer) return;

        let mountPromise = null;

        const mountVueModal = () => {
            if (mountNode.__vueMounted) {
                return Promise.resolve();
            }

            if (!mountPromise) {
                mountPromise = importer().then(({ default: Component }) => {
                    if (!mountNode.__vueMounted) {
                        createApp(Component, {
                            id: modalId,
                            eventName,
                            teleportTargetId: '#class__container',
                            triggerSelector: '[data-modal-component]',
                        }).mount(mountNode);

                        mountNode.__vueMounted = true;
                    }
                });
            }

            return mountPromise;
        };

        const openVueModal = () => {
            mountVueModal().then(() => {
                document.dispatchEvent(new CustomEvent(`${eventName}:open`));
            });
        };

        vueTriggers.forEach((trigger) => {
            trigger.addEventListener(
                'click',
                (e) => {
                    e.preventDefault();
                    openVueModal();
                },
                true,
            );
        });

        const preloadModal = () => mountVueModal();
        if (typeof requestIdleCallback === 'function') {
            requestIdleCallback(preloadModal, { timeout: 1500 });
        } else {
            setTimeout(preloadModal, 0);
        }
    },
    false,
);
